import classNames from 'classnames'
import getConfig from 'next/config'
import Image from 'next/image'
import { Fragment, useState } from 'react'
import CustomImage from 'src/components/Image'
import useI18n from 'src/hooks/use_i18n'
import styles from './index.module.scss'

const { publicRuntimeConfig } = getConfig()

const assetPrefix = publicRuntimeConfig.assetPrefix || ''

export default function AutoTrack() {
  const { $t } = useI18n()
  const [idx, setIdx] = useState<number>(0)
  const [featureList] = useState<Record<'icon' | 'title' | 'desc' | 'url', string>[]>([
    {
      url: assetPrefix + '/assets/images/track_page/part2_01',
      icon: assetPrefix + '/assets/images/track_page/new_1.svg',
      title: $t('ResWwwPTrackCenterLP.global.__section2_freeTrackingSelectorTitle'),
      desc: $t('ResWwwPTrackCenterLP.global.__section2_freeTrackingSelectorDes')
    },
    {
      url: assetPrefix + '/assets/images/track_page/part2_02',
      icon: assetPrefix + '/assets/images/track_page/new_2.svg',
      title: $t('ResWwwPTrackCenterLP.global.__section2_unLimitedFreeSelectorTitle'),
      desc: $t('ResWwwPTrackCenterLP.global.__section2_unLimitedFreeSelectorDes')
    },
    {
      url: assetPrefix + '/assets/images/track_page/part2_03',
      icon: assetPrefix + '/assets/images/track_page/4.svg',
      title: $t('ResWwwPTrackCenterLP.global.__section2_estimatedArrivalSelectorTitle'),
      desc: $t('ResWwwPTrackCenterLP.global.__section2_estimatedArrivalSelectorDes')
    },
    {
      url: assetPrefix + '/assets/images/track_page/part2_04',
      icon: assetPrefix + '/assets/images/track_page/7.svg',
      title: $t('ResWwwPTrackCenterLP.global.__section2_dataAnalysisSelectorTitle'),
      desc: $t('ResWwwPTrackCenterLP.global.__section2_dataAnalysisSelectorDes')
    }
  ])

  return (
    <section className={classNames(styles['auto-track'])}>
      <div className={styles.wrapper}>
        <h2 className={classNames(styles.title)}>{$t('ResWwwPTrackCenterLP.global.__section2_orderTrackingText')}</h2>
        <p className={styles.desc}>{$t('ResWwwPTrackCenterLP.global.__section2_buildBrandy')}</p>

        {/* >1024 */}
        <div className={classNames('flex items-center', styles.horizontal)}>
          <div className={classNames('flex-1', styles.cover)}>
            {featureList.map((ele, key) => (
              <CustomImage
                src={ele.url}
                alt="17TRACK"
                className={classNames('lazy-image-fill', styles['fade-out'], { [styles['fade-in']]: key === idx })}
                key={key}
                width={0}
                height={0}
              />
            ))}
          </div>
          <div className={classNames(styles.content)}>
            {featureList.map((ele, key) => (
              <div
                key={ele.icon}
                className={classNames('flex', styles.info, { [styles.active]: key === idx })}
                onMouseEnter={() => setIdx(key)}
              >
                <Image src={ele.icon} alt="17TRACK" width={60} height={key > 1 ? 89 : 65} className="mr-5" />
                <div>
                  <h2>{ele.title}</h2>
                  <p>{ele.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* <=1024 */}
        <div className={classNames(styles.content, styles.vertical)}>
          {featureList.map((ele, key) => (
            <Fragment key={key}>
              <div className={classNames('flex items-center', styles.info)}>
                <div>
                  <Image src={ele.icon} alt="17TRACK" width={60} height={60} className={classNames('mr-5')} />
                </div>
                <div>
                  <h2>{ele.title}</h2>
                  <p>{ele.desc}</p>
                </div>
              </div>
              <div className={classNames(styles.cover)}>
                <CustomImage src={ele.url} alt="17TRACK" fill className="lazy-image-fill" />
              </div>
            </Fragment>
          ))}
        </div>
      </div>
    </section>
  )
}
